<template>
  <header-section
    title="Usuarios"
    :tabs="tabs"
  >
    <router-view />
  </header-section>
</template>

<script>
import BaseSection from "@/components/global/layout/BaseSection.vue";

export default {
  name: "users-tabs-container",
  extends: BaseSection,
  data: () => ({
    tabs: [
      { url: { name: "users" }, title: "Académico" },
      //{ url: { name: "users-payments" }, title: "Pagos" },
    ],
  }),
};
</script>